module.exports = __webpack_public_path__ + "SC05_Player.9c96004a.atlas";